import React from 'react';
import { Table } from 'antd';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import getExpandedRowColumns from './expandedRowColumns';

const ExpandedExperimentsTable = ({
  data = [],
  loading = false,
  experimentDrafts = {},
  onDraftChange,
  onExperimentUpdate,
  onOpenAIPanel,
  onAcceptExperiment,
  onRejectExperiment,
  onTableChange,
  clientId
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Get columns using the shared column definitions
  const columns = getExpandedRowColumns({
    experimentDrafts,
    onDraftChange,
    onExperimentUpdate,
    onOpenAIPanel,
    onAcceptExperiment,
    onRejectExperiment,
    navigate,
    t,
    clientId
  });

  return (
    <Box
      sx={{
        padding: '16px',
        backgroundColor: '#FFFFFF',  // White background for entire container
        // Fix fixed column background to be transparent instead of white
        '& .ant-table-cell-fix-right': {
          backgroundColor: 'transparent !important',
        },
        '& .ant-table-cell-fix-right-first': {
          backgroundColor: 'transparent !important',
        },
        '& .ant-table-cell-fix-right::after': {
          backgroundColor: 'transparent !important',
        }
      }}
    >
      {/* Wrapper with rounded border to highlight the table */}
      <Box
        sx={{
          border: '1px solid #E5E5E5',
          borderRadius: '8px',
          overflow: 'hidden',
          overflowX: 'auto',
          padding: '12px',  // Inner padding between border and table content
        }}
      >
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={false}
          size="small"
          rowKey="experimentId"
          scroll={{ x: 1200 }}
          tableLayout="fixed"
          onChange={onTableChange}
        />
      </Box>
    </Box>
  );
};

export default ExpandedExperimentsTable;
